import React from 'react';
import styled from 'styled-components';
import useConfig from '@empiriecom/module-components/hooks/useConfig';
import { FragmentConfiguration } from '@/config';
import { IconProps } from './types';

const StarIcon = (props: IconProps): JSX.Element => {
  const config: FragmentConfiguration = useConfig();
  return config.customerRatings.iconType === 'SHOE' ? (
    // allow prop spreading for svg icon
    // eslint-disable-next-line react/jsx-props-no-spreading
    <svg viewBox="0 0 32 32" {...props}>
      <path d="M1.092 27.128c0 0-0.435-0.607 0.582-1.372 1.027-0.771 5.253-3.298 6.416-3.988 1.163-0.693 2.036-1.539 2.036-1.539s2.617-0.154 3.462-0.301c0.837-0.151 0.728-0.686 1.491-1.533 0.763-0.85 4.080-6.136 4.080-6.136s1.934-3.333 2.917-4.908c0.982-1.573 3.318-3.318 3.79-3.509 0.474-0.191 0.765-2.398 1.454-1.708 0.693 0.689 2.545 2.908 2.918 3.681 0.363 0.763 1.091 3.335 0.582 4.289-0.51 0.964-0.438 1.153-0.873 2.766-0.443 1.605-0.162 2.413-0.299 4.903-0.144 2.766-0.582 7.065-0.582 7.065h-1.745v-10.12c0 0-0.075-0.623-0.872 0-0.802 0.602-1.357 0.639-2.043 2.45-0.691 1.8-1.454 4.982-2.329 6.442-0.872 1.454-0.909 2.801-3.206 3.375-2.291 0.572-6.409 0.457-6.409 0.457h-10.786l-0.582-0.313z" />
    </svg>
  ) : (
    // allow prop spreading for svg icon
    // eslint-disable-next-line react/jsx-props-no-spreading
    <svg viewBox="0 0 36 36" {...props}>
      <path d="M18 28.319l-10.777 6.556 2.797-12.455-9.458-8.403 12.506-1.142 4.932-11.749 4.932 11.749 12.506 1.142-9.458 8.403 2.797 12.455z" />
    </svg>
  );
};

const StyledRatingIcon = styled(StarIcon)`
  width: ${({ size = '1rem' }) => size};
  height: ${({ size = '1rem' }) => size};
  vertical-align: middle;
`;

export default StyledRatingIcon;
